<template>
  <BaseTemplate>
    <div class="password-reissue">
      <Title jpn="Password Issue" />
      <div class="description">
        <span class="text">Temporary password to your registered email address</span>
        <span class="text">We will send it to you.</span>
      </div>
      <div class="mail-text-container">
        <LabelInput
          class="label-input"
          labelText="Email address"
        >
          <TextBox
            class="text-box mail"
            placeholder=""
            @handleTextInput="inputMail"
          />
        </LabelInput>
        <ErrorMessage
          v-if="errorMessageMail"
          class="error-message"
          :message="errorMessageMail"
        />
      </div>
      <BlackGradationButton
        class="square-button send-mail"
        text="Send mail"
        @handleSquareBtnClick="sendPasswordMail"
      />
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import LabelInput from '@/components/molecules/LabelInput.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n';

export default {
  name: 'PasswordReissue',
  mixins: [t],

  components: {
    BaseTemplate,
    TextBox,
    ErrorMessage,
    Title,
    BlackGradationButton,
    LabelInput,
  },

  data: () => ({
    mail: null,
    errorMessageMail: null,
  }),

  computed: {
    ...mapGetters({
      reissuePasswordOneTimeResult: 'user/reissuePasswordOneTimeResult',
    }),
  },

  watch: {
    reissuePasswordOneTimeResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/clearReissuePasswordResult');
          this.$router.push('/onetime-password-reissue');
        } else {
          const { mail } = newVal.errors;
          this.errorMessageMail = mail ? mail[0] : null;
        }
      }
    },
  },

  methods: {
    inputMail(mail) {
      this.mail = mail;
    },
    sendPasswordMail() {
      const postParams = {
        mail: this.mail,
      };
      this.$store.dispatch('user/reissuePasswordOneTime', { postParams });
    },
  },
};
</script>

<style lang="scss" scoped>
.password-reissue{
  max-width: 680px;
  min-height: 100%;
  padding: 70px 30px 0px;
  margin: 0px auto;
  text-align: center;
  @include appendMap($backgroundStyleMap);
  .password-reissue-title{
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
      color: $white;
    }
  }
  .description{
    display: flex;
    flex-direction: column;
    height: 43px;
    margin-top: 40px;
    .text{
      font-family: $notoSans;
      font-size: 14px;
      line-height: 23.4px;
      color: $white;
    }
  }
  .mail-text-container{
    width: 315px;
    margin: 20px auto 0 auto;
    .text-box{
      &.mail{
      }
    }
  }
  .square-button{
    width: 200px;
    height: 50px;
    margin: 40px auto 0px;
  }
  .error-message {
    margin-top: 2px;
    background-color: rgba(8, 27, 64, 1);
    padding: 2px 10px;
  }
}
</style>
